import { ActivityEntityName, AssetTypeEntity, Attachment, CodeCategory, CodeStatus, Entity, FormPage, GeneralSetting, PriorityTiny, QuoteStatus, Site, TaskTarget, WithConnectStamp, WorkOrderStatus, } from '..';

export enum FormTemplateStatus {
    Draft = 'Draft',
    Public = 'Public'
}

export enum FormSource {
    Office = 'Office',
    Supervisor = 'Supervisor',
    Field = 'Field'
}

export enum FormPrintLayout {
    Standard = 'Standard',
    DocumentTheme = 'Document Theme'
}

export interface FormTemplate extends WithConnectStamp {

    _id: string;
    title: string;
    subTitle: string;
    type: string;
    pages: FormPage[];
    active?: boolean;
    status: FormTemplateStatus;
    mergeWith: ActivityEntityName;
    variables?: any;
    options?: any;
    rules?: any; // TODO: Review Mongoose - was any[] but to change to any because mongoose issue https://github.com/Automattic/mongoose/issues/10617
    thankYouPage?: any;
    readonly: boolean;
    version: number;
    categories: Entity[];
    tags?: Entity[];
    backgroundColor: string;
    valid?: boolean;
    target?: TaskTarget;

    restrictions?: Entity[]; // TODO: Extend this to allow multiple types entities

    restrictionRules?: any;

    printLayout?: FormPrintLayout
    documentTheme?: Attachment;

    // For printing PDF purpose since they need dateFormat settings
    generalSetting?: GeneralSetting;

    enableLivePreview?: boolean;

}

export interface FormTemplateSummary {
    _id: string;
    title: string;
    subTitle: string;
    responseCount?: number;
    mergeWith: ActivityEntityName;
    categories: Entity[];
    tags: Entity[];
    backgroundColor: string;
    valid?: boolean;
    target?: TaskTarget;

    restrictions?: Entity[];
    restrictionRules?: any;
}

export interface FormJobEntity {
    JobDescription: string;
    JobName: string;
    JobNumber: string;
    JobDueDate: string;
    JobStartDate: string;
    JobCompletedDate: string;
    JobCustomer: string;
    JobSiteAddress: string;
    JobOwner: string;
    JobPriority: PriorityTiny;
    JobStatus: Entity;
    JobType: Entity;
    JobWorkOrders: JobWorkOrder[];
    JobCustomFields: any;
    JobTimezone: string;
    JobBillingCompany: Entity;
    JobBillingCompanyName: string;
    JobBillingCompanyLogo: string;
    JobCustomerEmail: string;
    JobCustomerNumber: string;
    JobSiteContact: string;
    JobSiteNumber: string;
}

export interface FormWorkOrderEntity extends FormJobEntity {
    JobId: string;
    // JobDescription: string;
    // JobNumber: string;
    // JobDueDate: string;
    // JobStartDate: string;
    // JobCompletedDate: string;
    // JobCustomer: string;
    // JobSiteAddress: string;
    // JobOwner: string;
    // JobPriority: PriorityTiny;
    // JobStatus: Entity;
    // JobType: Entity;
    // JobBillingCompany: Entity;
    // JobBillingCompanyName: string;
    // JobBillingCompanyLogo: string;
    // JobCustomerEmail: string;
    // JobCustomerNumber: string;
    // JobSiteContact: string;
    // JobSiteNumber: string;
    WorkOrderNumber: string;
    WorkOrderDueDate: string;
    WorkOrderStartDate: string;
    WorkOrderCompletedDate: string;
    WorkOrderTechnician: string;
    WorkOrderTechnicianABN: string;
    WorkOrderTechnicianPhone: string;
    WorkOrderTechnicianEmail: string;
    WorkOrderResources: string;
    WorkOrderResourcesRaw: string[];
    WorkOrderName: string;
    WorkOrderStatus: Entity;
    WorkOrderCodes: FormCode[];
    WorkOrderCustomFields: any;
    WorkOrderTimezone: string;
    WorkOrderAlternateTimezone: string;
}

export interface FormQuoteEntity {
    QuoteDescription: string;
    QuoteNumber: string;
    QuoteDueDate: string;
    QuoteApprovalDate: string;
    QuoteCustomer: string;
    QuoteSiteAddress: string;
    QuoteOwner: string;
    QuoteStatus: QuoteStatus;
    QuoteType: Entity;
    QuoteCodes: FormCode[];
}

export interface FormAssetEntity {
    AssetId: string;
    AssetName: string;
    AssetType: AssetTypeEntity;
    AssetParent: Entity;
    AssetSiteAddress: string;
    AssetLinkedCompany: string;
    AssetSerialNumber: string;
    AssetModel: string;
    AssetBarcode: string;
    AssetTags: string;
    AssetLinkedCrew: string;
    AssetCustomFields: any;
}

export interface JobWorkOrder {
    _id: string;
    workOrderNumber: string;
    status: WorkOrderStatus;
    codes: FormCode[];
    priority: Entity;
    site?: Site;
    name?: string;
    completedDate: string;
    startDate: string;
    dueDate: string;
}

export interface FormCode {
    name: string;
    category: CodeCategory;
    description: string;
    location?: string;
    quantity?: number;
    buyPrice?: number;
    sellPrice?: number;
    status?: CodeStatus;
}
